import * as React from 'react';
import './App.css';

import HeaderComponent from "./components/homeHeader/HeaderComponent";
import MenuComponent from "./components/menuComponent/MenuComponent";
import BannerComponent from "./components/bannerComponent/BannerComponent";
import SwiperComponent from "./components/swiperComponent/SwiperComponent";
import PostsComponent from "./components/PostsComponent/PostsComponent";
import  FooterComponent from "src/components/footerComponent/FooterComponent";
import MasonryComponent from "./components/masonryComponent/MasonryComponent";
import ToastComponent from '../src/components/toastComponent';
import { slide as Menu } from 'react-burger-menu'

import { Helmet } from 'react-helmet'
import {inspect} from "util";
import {connect} from "react-redux";
import MenuLeftComponent from "./components/menuLeftComponent/MenuLeftComponent";
import EditProfileComponent from "./components/editProfileComponent/EditProfileComponent";
import {IMenuLeftComponentProps} from "./components/menuLeftComponent/IMenuLeftComponentProps";
import * as actions from "./actions/userAction";
import { withRouter } from "react-router-dom";
import MenuLeftemobile from "./components/menuLeftMobile/MenuLeftemobile";
import {toast, ToastContainer} from "react-toastify";
import {IToastProps} from "./components/toastComponent/IToastProps";


export interface IAppProps{
openSide ?: any , history ?: any , handleSignOut ?: any , toast ? :any
}
export interface IAppState{

}
class App extends React.Component  <IAppProps , IAppState> {


    constructor(props : IAppProps) {
        super(props);

    }

    componentWillReceiveProps(nextProps: Readonly<IAppProps>, nextContext: any): void {

        console.log(this.props.toast , 'tttttttt')

        nextProps.toast.show ?
            (
                toast(nextProps.toast.title)
            ) :
            null

    }


    logout() {


        this.props.history.push('/')

        this.props.handleSignOut(() => {
            console.log('Out');

        });
    }





  public render() {

console.log(this.props.toast)
console.log('tttt')

    return (
        <div>

         {/* <Menu left
                isOpen={this.props.openSide}
          >
          </Menu>*/}
          <MenuLeftemobile/>




            {/*
          <ToastComponent />
*/}
            <Helmet
              titleTemplate="%s - Gif تونسي"
              defaultTitle="Gif تونسي"
            >
                <title>Acceuil</title>
            </Helmet>
            <HeaderComponent/>
            <ToastContainer />
            <MenuComponent/>
            <BannerComponent/>
            <SwiperComponent/>
            <MasonryComponent title={'Découvrir'} size={10} url='https://europe-west1-ttgif-3c665.cloudfunctions.net/getgifs' />
            <FooterComponent />
        </div>
    );
  }
}
const mapDispatchToProps = (dispatch: any, ownProps: IAppProps) => {
    return {
        handleSignOut: (cb) => dispatch(actions.signout(cb))
    }
};

function mapsStateToProps(state) {
    return {
        openSide : state.toast.openSide,
        toast: state.toast
    };
}

export default connect(mapsStateToProps, mapDispatchToProps)(withRouter(App));



// WEBPACK FOOTER //
// ./src/App.tsx